export default {
  sidePanelSubtitle: "Let's look at what was produced so far.",
  sidePanelTitle: "Second batch is midway through.",
  subtitle: "Output volume for second batch so far",
  tag: "Middle of the day",
  title: "Production overview",
  ctaText: "Show my inventory overview"
};
